import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Menu, X } from "lucide-react";

const LINKS = [
  ["Platform", "/platform"],
  ["Pricing", "/pricing"],
  ["Success", "/success"],
  ["Contact", "/contact"],
];

export const MzHeader = ({ ctaHref }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div aria-hidden className="mz-goldbar" />
      <header
        className="fixed top-[3px] inset-x-0 z-50 backdrop-blur-xl bg-white/70 border-b border-[#D4AF37]/20"
        data-testid="monetize-header"
      >
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo" aria-label="GoldKey Studio home">
            <span className="mz-gold-fill mz-h w-9 h-9 rounded-xl flex items-center justify-center text-[13px] font-bold text-[#1a1206]">
              GK
            </span>
            <span className="mz-h text-[15px] font-semibold tracking-tight">
              GoldKey <span className="mz-gold-text">Studio</span>
            </span>
          </Link>
          <nav className="hidden md:flex items-center gap-8" data-testid="nav-links" aria-label="Primary">
            {LINKS.map(([label, to]) => (
              <Link key={label} to={to} className="text-[13px] font-medium text-neutral-500 hover:text-black transition-colors">
                {label}
              </Link>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <Link
              to="/login"
              data-testid="monetize-header-login"
              className="hidden sm:block text-[13px] font-medium text-neutral-500 hover:text-black transition-colors"
            >
              Log in
            </Link>
            <a href={ctaHref} data-testid="monetize-header-cta" className="mz-btn-gold !py-2 !px-4 !text-[12.5px]">
              Enable the Hub
              <ArrowUpRight size={13} strokeWidth={2.2} />
            </a>
            <button
              type="button"
              onClick={() => setOpen(!open)}
              data-testid="monetize-mobile-menu"
              aria-label="Toggle menu"
              className="md:hidden p-2 -mr-2 text-neutral-700"
            >
              {open ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>
        {open && (
          <div className="md:hidden border-t border-neutral-100 bg-white/95 backdrop-blur-xl px-5 py-4 flex flex-col gap-4" data-testid="monetize-mobile-nav">
            {LINKS.map(([label, to]) => (
              <Link key={label} to={to} className="text-sm font-medium text-neutral-700" onClick={() => setOpen(false)}>
                {label}
              </Link>
            ))}
            <Link to="/login" className="text-sm font-medium text-neutral-700" onClick={() => setOpen(false)}>
              Log in
            </Link>
          </div>
        )}
      </header>
    </>
  );
};
